import { isValidPhoneNumber } from "@ews-admin/global-design-system";

/**
 * MED-1653: a complete phone number for a new account. The design system's
 * isValidPhoneNumber accepts 1 to 17 digits, so "12" (sent as "+22112" by
 * PhoneInput) passed. With a country code, E.164 numbers have 10 to 15 digits
 * here (Senegal +221 and 9 digits, Chad +235 and 8); without one, 8 to 15.
 */
export const isCompletePhoneNumber = (value: string): boolean => {
  if (!isValidPhoneNumber(value)) return false;
  const trimmed = value.trim();
  const digits = trimmed.replace(/\D/g, "").length;
  return trimmed.startsWith("+") ? digits >= 10 && digits <= 15 : digits >= 8 && digits <= 15;
};

/**
 * MED-1653: the rule for every phone field of the manager dashboard. A number must be complete,
 * except an existing one left as it was (`existing`), which only needs the old format check so
 * that an older short number never blocks saving the rest of a form.
 */
export const isAcceptablePhoneNumber = (
  value: string,
  existing?: string | readonly string[],
): boolean => {
  const kept = existing === undefined ? [] : typeof existing === "string" ? [existing] : existing;
  const trimmed = value.trim();
  if (kept.some((phone) => phone && phone.trim() === trimmed)) {
    return isValidPhoneNumber(trimmed);
  }
  return isCompletePhoneNumber(trimmed);
};
